export default __webpack_public_path__ + "static/media/treat-yourself-2048w.c5c6c210.webp";